import { CollectionService } from './index';

const TraitService = CollectionService('traits');

export default TraitService;
